export const SEVERITY_NAMES = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
  info: "Info",
};

export const BASE_SEVERITY_OBJECT: Record<string, number> = {
  [SEVERITY_NAMES.critical]: 0,
  [SEVERITY_NAMES.high]: 0,
  [SEVERITY_NAMES.medium]: 0,
  [SEVERITY_NAMES.low]: 0,
};

export const ALL_SEVERITIES = Object.values(SEVERITY_NAMES);

export const BASE_SEVERITIES = Object.keys(BASE_SEVERITY_OBJECT);

export const CAPITALIZED_SEVERITIES = ["Critical", "High", "Medium", "Low"];

export const UPPERCASE_SEVERITIES = {
  CRITICAL: "CRITICAL",
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
  INFO: "INFO",
};

export const FINDING_SCORE_SEVERITY_WEIGHT = {
  CRITICAL: 10,
  HIGH: 8,
  MEDIUM: 5,
  LOW: 1,
  INFO: 0,
};

export const SSDLC_WEIGHT = {
  MAX: 10,
  HIGH: 8,
  MEDIUM: 5,
  LOW: 1,
};
